<template>
  <div class="content">
    <div class="body" :loading="listLoading">
      <div class="search-box min">
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.id" clearable filterable>
            <Option v-for="(item, index) in companyList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
      <div class="tableBox">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="action">
            <div>
              <span class="table-btn" @click="showDetail(row)">查看</span>
              <span class="table-btn" @click="handleDownload(row)">下载</span>
            </div>
          </template>
        </Table>
      </div>
      <div class="pageBox">
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />
      </div>
    </div>

    <!-- pdf预览 -->
    <pdf-view ref="pdfView" />
  </div>
</template>
  <script>
import pdfView from '@/components/commons/pdfView';
import { pageTool, common } from '@/api/mixins';
let vm;
export default {
  mixins: [pageTool, common],
  components: { pdfView },
  data: () => ({
    columns: [
      {
        title: '保司简称',
        key: 'name',
        minWidth: 100,
        align: 'center'
      },
      {
        title: '保司全称',
        key: 'fullName',
        minWidth: 100,
        align: 'center'
      },
      {
        title: '操作',
        width: 160,
        align: 'center',
        slot: 'action'
      }
    ],
    selectArr: [],
    companyList: []
  }),
  mounted() {
    vm = this;
  },
  created() {
    vm = this;
    this.queryCompanyList();
    this.initListAjax('/buz/insuranceCompany/information/list');
  },
  methods: {
    listCallback(res) {
      res.data.forEach(item => {
        if (item.intro && item.intro.length) {
          item.intro = JSON.parse(item.intro);
        }
      });
    },
    showPdf(row) {
      if (row.intro && row.intro.length) {
        this.$refs.pdfView.open(row.intro);
      }
    },
    showDetail(item) {
      if (item.id) {
        this.$router.push({
          path: '/companyManage/detail',
          query: {
            id: item.id
          }
        });
      }
    },
    // 查询所有保司
    queryCompanyList() {
      vm.$http({
        url: '/buz/insuranceCompany/query/list',
        type: 'GET',
        data: {}
      }).then(res => {
        vm.companyList = res.data;
      });
    },
    setListParams(params) {
      params.type = '2';
    },

    // 页面切换
    pageChange(index) {
      vm.pageNum = index;
      vm.getList();
    },
    handleDownload(row) {
      this.$notice.inquiry(`是否下载该保司全部文件资料?`).then(() => {
        vm.$units.downloadFile('/buz/insuranceCompany/info/download', { companyId: row.id, ...this.searchParams }, 'GET');
      });
    }
  }
};
</script>
  <style lang='scss' scoped>
.content {
  min-width: 1080px;
  min-height: calc(100vh);
  background: #fff;
  .body {
    background: #fff;
    padding: 25px;
    .search-box {
      margin-bottom: 10px;
      .input-item1 {
        width: 33.3%;
        display: inline-block;
        position: relative;
        .label {
          width: 117px;
          position: absolute;
          left: 0;
          top: 0;
          margin: auto;
          line-height: 32px;
          text-align: right;
        }
        .ivu-input-wrapper {
          display: inline-block;
          margin-left: 127px;
          width: calc(100% - 137px);
        }
      }
    }
    .toolbox {
      line-height: 46px;
      background-color: #f8f8f9;
      border-top: 1px solid #e8eaec;
      border-left: 1px solid #e8eaec;
      border-right: 1px solid #e8eaec;
      .add-btn {
        float: right;
        margin-right: 10px;
      }
    }
    .tableBox {
      padding-bottom: 25px;
      background-color: #fff;
      position: relative;
      z-index: 100;
      .bjbtn {
        color: #236dff;
        font-size: 14px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .table-top {
      margin-top: 30px;
    }
  }
}
/deep/ .insuranceModal {
  letter-spacing: 1px;
}
/deep/ .ivu-modal-body {
  padding: 40px 30px 10px 30px;
  .descitem {
    .ivu-form-item-label {
      width: 114px !important;
    }
  }
}
</style>